import {
	BarChart3,
	BookOpen,
	CalendarClock,
	Inbox,
	type LucideIcon,
	NotebookPen,
	Repeat,
	Settings,
	Sun,
	Timer,
	Wallet,
} from "lucide-react";

export type NavItem = {
	title: string;
	url: string;
	icon: LucideIcon;
	description: string;
	/** Shown in the mobile bottom bar; the rest sit under "More". */
	primary?: boolean;
};

export type NavGroup = { label: string; items: NavItem[] };

export const navGroups: NavGroup[] = [
	{
		label: "Daily",
		items: [
			{
				title: "Today",
				url: "/today",
				icon: Sun,
				primary: true,
				description: "Must-wins, next block, allowance, habits due and study.",
			},
			{
				title: "Inbox",
				url: "/inbox",
				icon: Inbox,
				primary: true,
				description: "Everything captured and not yet planned.",
			},
			{
				title: "Plan",
				url: "/plan",
				icon: CalendarClock,
				primary: true,
				description: "Time-block the day and see the week.",
			},
		],
	},
	{
		label: "Life",
		items: [
			{
				title: "Money",
				url: "/money",
				icon: Wallet,
				primary: true,
				description: "Wallets, transactions, budget and allowance.",
			},
			{
				title: "Habits",
				url: "/habits",
				icon: Repeat,
				description: "Check-offs, streaks and heatmaps.",
			},
			{
				title: "Focus",
				url: "/focus",
				icon: Timer,
				description: "Timer, focus mode and distraction log.",
			},
			{
				title: "Study",
				url: "/study",
				icon: BookOpen,
				description: "Tracks, sessions and due flashcards.",
			},
		],
	},
	{
		label: "Reflect",
		items: [
			{
				title: "Reviews",
				url: "/reviews",
				icon: NotebookPen,
				description: "Morning ritual, evening shutdown and weekly review.",
			},
			{
				title: "Insights",
				url: "/insights",
				icon: BarChart3,
				description: "Weekly score and trends.",
			},
		],
	},
];

export const settingsItem: NavItem = {
	title: "Settings",
	url: "/settings",
	icon: Settings,
	description: "Profile, theme, score weights and data export.",
};

export const allNavItems: NavItem[] = [...navGroups.flatMap((g) => g.items), settingsItem];

export function findNavItem(pathname: string): NavItem | undefined {
	return allNavItems.find((i) => pathname === i.url || pathname.startsWith(`${i.url}/`));
}
